<template>
  <v-container fluid class="px-0 py-0">
    <slot name="bar">
      <v-system-bar height="24">
        <span v-if="!!title"><span>{{ title }}</span></span>
        <v-spacer></v-spacer>
        <!--        <v-chip v-if="!!aggregateStore" small>buffer length: {{ Object.keys(aggregateStore.uid_dict).length }}</v-chip>-->
        <CommonQR v-if="!!qrcode" :value="qrcode" :text="qrcode"></CommonQR>
        <CommonSwitchFilterGroup
            v-if="!!state.common && !!state.common.bar_switches && state.common.bar_switches.length > 0"
            v-model="state.common.bar_switches"
            :filter-names.sync="state.selectedSwitches"
            x-small
        ></CommonSwitchFilterGroup>
        <v-icon small v-if="state.showCreateEdit === false" @click="state.showCreateEdit=!state.showCreateEdit">
          mdi-timer-off-outline
        </v-icon>
        <v-icon small v-if="state.showCreateEdit === true" @click="state.showCreateEdit=!state.showCreateEdit">
          mdi-timer-outline
        </v-icon>
        <CommonRefresh v-if="items === null" :loading="state.loading" @click="update()"></CommonRefresh>
      </v-system-bar>
    </slot>
    <v-data-table
        ref="DataTable"
        v-model="state.selected"
        :headers="state.filteredHeaders"
        dense
        :height="componentHeight - topHeight"
        :items="itemList"
        item-key="uid"
        :item-class="rowBackground || rowDefaultBackground"
        class="elevation-1"
        :options.sync="state.options"
        :server-items-length="serverItemsLength"
        :show-select="showSelect"
        :single-select="singleSelect"
        :footer-props="state.footerProps"
        :hide-default-footer="hideDefaultFooter"
        :hide-default-header="hideDefaultHeader"
        fixed-header
        @toggle-select-all="onToggleSelectAll($event)"
    >
      <template v-slot:body.prepend="{ headers }">
        <slot name="body.prepend"></slot>
      </template>
      <template v-slot:top>
        <slot name="top">
          <v-toolbar dense :height="heightToolbar">
            <slot name="top.bar">
              <v-row class="flex-nowrap">
                <slot name="top.bar.status">
                  <CommonFilterGroup
                      v-if="items === null && !!state.common && !!state.common.bar_statuses && state.common.bar_statuses.length > 0"
                      v-model="state.common.bar_statuses"
                      :filter-names.sync="state.selectedStatuses"
                  ></CommonFilterGroup>
                </slot>
                <slot name="top.bar.filter">
                  <CommonFilterGroup
                      v-if="items === null && !!state.common && !!state.common.bar_filters && state.common.bar_filters.length > 0"
                      v-model="state.common.bar_filters"
                      :filter-names.sync="state.selectedFilters"
                  ></CommonFilterGroup>
                </slot>
                <slot name="top.bar.info"></slot>
              </v-row>
              <slot name="top.bar.search">
                <v-container fluid>
                  <slot name="top.bar.search.qsearch">
                  </slot>
                </v-container>
                <slot name="top.bar.search.qsearchflag">
                    <v-checkbox v-model="state.quick_search_flag" label="QS" dense class="mt-3"></v-checkbox>
                  </slot>
                <v-container fluid>
                  <slot name="top.bar.search.search">
                    <BaseFieldString v-model="state.search" label="Search (example: phrase1 && phrase2 && ...)" dense
                                     clearable=""></BaseFieldString>
                  </slot>
                </v-container>
              </slot>
              <slot name="top.bar.action">
                <slot name="top.bar.action.left"></slot>
                <slot name="top.bar.action.middle">
                </slot>
                <slot name="top.bar.action.right"></slot>
              </slot>
              <slot name="top.bar.overlay"></slot>
            </slot>
          </v-toolbar>
        </slot>
        <v-divider></v-divider>
      </template>
      <template v-for="header in state.headers" v-slot:[`header.${header.value}`]="{ header }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span
                v-bind="$attrs"
                v-on="on"
                class="d-inline-block text-truncate my-0 py-0"
                :style="styleText(header.width)"
            >{{ header.text }}</span>
          </template>
          <span>{{ header.text }}</span>
        </v-tooltip>
      </template>
      <template v-for="header in state.headers" v-slot:[`item.${header.value}`]="{item}">
        <slot :name="[`item.${header.value}`]" :item="item">
          <span v-if="header.type === 'bool'">
            <v-icon small v-if="item[`${header.value}`]" :color="header.color">mdi-check-bold</v-icon>
          </span>
          <span v-else-if="header.type === 'qrcode'">
            <CommonQR
                v-if="!!item[`${header.value}`]"
                :color="header.color"
                :value="item[`${header.value}`]"
                :text="item[`${header.value}`]"
            ></CommonQR>
          </span>
          <span v-else-if="header.type === 'text'">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span
                    v-bind="$attrs"
                    v-on="on"
                    class="d-inline-block text-truncate mt-1"
                    :style="styleText(header.width)"
                >{{ item[`${header.value}`] }}</span>
              </template>
              <span>{{ item[`${header.value}`] }}</span>
            </v-tooltip>
          </span>
          <span v-else-if="header.type === 'date'">
            {{ item[`${header.value}`] | moment("DD.MM.YY") }}
          </span>
          <span v-else-if="header.type === 'datetime'">
            {{ item[`${header.value}`] | moment("DD.MM.YY HH:mm") }}
          </span>
          <span v-else-if="header.type === 'datetime_long'">
            {{ item[`${header.value}`] | moment("DD.MM.YY HH:mm:ss") }}
          </span>
          <span v-else-if="header.type === 'status'">
            <BaseStatusIcon :value="item[`${header.value}`]"></BaseStatusIcon>
          </span>
          <span v-else-if="header.value === 'is_saved'">
            <CommonIsSaved small :value="item[`${header.value}`]"></CommonIsSaved>
          </span>
          <span v-else-if="header.value === 'task_dto'">
            <CommonTaskIcon :small="true" :source_uid="item.uid"></CommonTaskIcon>
          </span>
          <span v-else-if="header.type === 'drag'">
            <div class="handle grab">
              <v-icon small class="d-flex justify-center">mdi-drag-variant</v-icon>
            </div>
          </span>
          <span v-else>
            {{ item[`${header.value}`] }}
          </span>
        </slot>
      </template>
      <template v-slot:item.deleted="{ item }">
        <slot name="item.deleted" :item="item">
          <v-icon v-if="!!item.deleted" small color="red lighten-2" class="d-flex justify-center">mdi-trash-can</v-icon>
        </slot>
      </template>
      <template v-slot:item.edit="{ item }">
        <slot name="item.edit" :item="item">
          <v-icon small @click="stateDetail.openDetailDialog(item)" color="edit_icon" class="d-flex justify-center">
            mdi-square-edit-outline
          </v-icon>
        </slot>
      </template>
      <template v-slot:item.edited_by_uid="{item}">
        <span
            v-if="!!aggregateStore && !!aggregateStore.rootData && !!item.edited_by_uid && !!aggregateStore.rootData[item.edited_by_uid]">{{
            aggregateStore.rootData[item.edited_by_uid].username
          }}</span>
      </template>
      <template v-slot:item.created_by_uid="{item}">
        <span
            v-if="!!aggregateStore && !!aggregateStore.rootData && !!item.created_by_uid && !!aggregateStore.rootData[item.created_by_uid]">{{
            aggregateStore.rootData[item.created_by_uid].username
          }}</span>
      </template>
      <template v-slot:footer.prepend>
        <slot name="footer.prepend">
          <CommonBtnActionGroup
              v-if="!!state.common && !!state.common.bar_actions && state.common.bar_actions.length > 0"
              v-model="state.common.bar_actions"
              :selected-items="state.selected"
              :filter-names.sync="state.selectedFilters"
              @action="onAction($event)"
              @embedded_action="$emit('embedded_action', $event)"
              @embedded_new="stateDetail.openDetailDialog(null)"
              @embedded_close="$emit('embedded_close')"
              @alternate_action="$emit('alternate_action', $event)"
          ></CommonBtnActionGroup>
        </slot>
        <slot name="footer.middle"></slot>
        <slot name="footer.page-text"></slot>
      </template>
    </v-data-table>
    <v-dialog
        ref="detailDialog"
        v-model="stateDetail.dialogDetail"
        persistent
        scrollable
        v-if="!!importDetailComponent & !!detailComponentPass"
        :width="stateDetail.width"
    >
      <component
          :uid-item="stateDetail.uidItem"
          :is="importDetailComponent"
          :store-name="detailStoreName"
          :dto-detail-query="dtoDetailQuery"
          :modalDialog="true"
          :route-full-screen="{name: detailComponent, params: {itemUid: stateDetail.uidItem}}"
          :parent-component="parentComponent"
          :main-validator="true"
          :embedded="embedded"
          @close="update()"
      ></component>
    </v-dialog>
  </v-container>
</template>

<script>
import {useAggregateStore, useBaseAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {defineStore} from "pinia";
import {debounce} from "debounce";
import {v4 as uuidv4} from "uuid";
import Sortable from "sortablejs";
import CommonFilterGroup from "@/components/Common/CommonFilterGroup";
import BaseFieldString from "@/components/Base/BaseFieldString";
import CommonBtnActionGroup from "@/components/Common/CommonBtnActionGroup";
import BaseTextSwitch from "@/components/Base/BaseTextSwitch";
import CommonSwitchFilterGroup from "@/components/Common/CommonSwitchFilterGroup";
import BaseStatusIcon from "@/components/Base/BaseStatusIcon";
import {useDetailStore} from "@/components/Common/CommonDetail";
import CommonRefresh from "@/components/Common/CommonRefresh";
import CommonToolbar from "@/components/Common/CommonToolbar";
import CommonIsSaved from "@/components/Common/CommonIsSaved";
import CommonTaskIcon from "@/components/Common/CommonTaskIcon";
import BaseIconSwitch from "@/components/Base/BaseIconSwitch";
import CommonQR from "@/components/Common/CommonQR.vue";

export const useTableStore = function (storeName, aggregateStoreName = null) {
  // console.log('useTableStore', storeName, aggregateStoreName)
  let aggregateStore = null
  if (!!aggregateStoreName)
    aggregateStore = useBaseAggregateStore(aggregateStoreName)()
  else
    aggregateStore = useAggregateStore()
  return defineStore(storeName, {
        state: () => ({
          uidItem: null,
          uidList: [],
          headers: [],
          loading: false,
          selected: [],
          common: {},
          selectedStatuses: null,
          selectedFilters: null,
          selectedSwitches: null,

          dtoListQuery: null,
          dtoActionCommand: null,
          detailStoreName: null,

          search: null,
          quick_search: null,
          quick_search_flag: true,
          filters: [],
          query_filters: null,

          height: null,
          showCreateEdit: false,
          options: {
            page: 1,
            itemsPerPage: 20,
            sortBy: ['uid'],
            sortDesc: [false, false, false, false, false, false, false],
            multiSort: false,
            mustSort: true,
            descending: false,
          },
          footerProps: {'items-per-page-options': [5, 20, 50, 100, 200, -1]},

          confirm_request: {
            dialog: false,
            message: null,
            request: {},
            type: 'info',
            timeout: -1,
          },
          showSelect: true,
          singleSelect: false,
          topToolbar: [],
          bottomToolbar: [],
          serverItemsLength: 0,
        }),
        getters: {
          proxyList() {
            let result = []
            if (!!aggregateStore && !!aggregateStore.rootData)
              this.uidList.forEach(uid => result.push(aggregateStore.rootData[uid]))
            return result
          },
          filteredHeaders() {
            if (this.showCreateEdit === false)
              return this.headers.filter((row) => !['created_on', 'created_by_uid', 'edited_on', 'edited_by_uid'].includes(row.value))
            else
              return this.headers
          },
        },
        actions: {
          callReceive() {
            this.loading = false
          },
          callBack() {
          },
          setExcludeFilters(uidList) {
            this.filters['exclude_uid'] = uidList
          },
          update() {
            // console.log('state update', storeName, this.dtoListQuery)
            this.loading = true
            aggregateStore.fetchList({
              storeName: storeName,
              dtoListQuery: this.dtoListQuery,
              search: this.search,
              quick_search: this.quick_search,
              quick_search_flag: this.quick_search_flag,
              filters: this.filters,
              query_filters: this.query_filters,
              options: this.options,
              selectedStatuses: this.selectedStatuses,
              selectedFilters: this.selectedFilters,
              selectedSwitches: this.selectedSwitches,
              callBack: this.callBack
            })
          },
          onAction({actionName, actionUid, data = null, callReceive = null}) {
            let selectedUid = []
            this.selected.forEach(row => {
              selectedUid.push(row.uid)
            })
            aggregateStore.fetchAction({
              storeName: storeName,
              dtoActionCommand: this.dtoActionCommand,
              uidItem: this.uidItem,
              uidSelected: selectedUid,
              actionName: actionName,
              actionUid: actionUid,
              data: data,
              callBack: null,
              callReceive: callReceive,
            })
          },
        },
      }
  )
}

export default {
  name: "CommonTable",

  props: {
    height: {default: null},
    qrcode: {default: null},
    embedded: {default: false},
    topHeight: {default: 0},
    hideDefaultFooter: {default: false},
    hideDefaultHeader: {default: false},
    items: {default: null},
    dtoListQuery: {type: [String], default: null},
    dtoDetailQuery: {type: [String], default: null},
    dtoValidateCommand: {type: [String], default: null},
    dtoActionCommand: {type: [String], default: null},
    dtoToolbarQuery: {type: [String], default: null},
    aggregateStoreName: {default: null},
    storeName: {
      type: [String], default() {
        return uuidv4()
      }
    },
    detailStoreName: {
      type: [String], default() {
        return uuidv4()
      }
    },
    mainValidator: {type: [Boolean], default: false},
    title: {type: [String], default: null},

    heightToolbar: {type: [Number], default: 48},
    detailComponentPass: {type: [String], default: null},
    parentComponent: {type: [String], default: null},
    showSelect: {default: true},
    singleSelect: {default: false},
    rowBackground: {default: null},
  },

  components: {
    'add-component': () => import(self.detailComponentPass),
    CommonFilterGroup,
    BaseFieldString,
    CommonBtnActionGroup,
    BaseTextSwitch,
    CommonSwitchFilterGroup,
    BaseStatusIcon,
    CommonRefresh,
    CommonToolbar,
    CommonIsSaved,
    CommonTaskIcon,
    BaseIconSwitch,
    CommonQR,
  },

  computed: {
    itemList() {
      if (this.items === null)
        return this.state.proxyList
      return this.items
    },
    serverItemsLength() {
      if (this.items === null)
        return this.state.serverItemsLength
      return this.items.length
    },
    queryParameters() {
      return {
        options: this.state.options,
        selectedStatuses: this.state.selectedStatuses,
        selectedFilters: this.state.selectedFilters,
        selectedSwitches: this.state.selectedSwitches,
        filters: this.state.filters,
        query_filters: this.state.query_filters,
      }
    },
    queryDebounceParameters() {
      return {
        search: this.state.search,
        search_quick: this.state.quick_search,
        search_quick_flag: this.state.quick_search_flag,
      }
    },
    detailComponent() {
      if (!!this.detailComponentPass)
        return this.detailComponentPass.split('/').pop()
    },
    importDetailComponent() {
      if (!!this.detailComponentPass) {
        return () => import("@/components" + this.detailComponentPass);
      }
    },
    componentHeight() {
      if (!!this.height)
        return this.height
      if (this.$vuetify.breakpoint.mobile)
        return this.$vuetify.breakpoint.height - 134 - 64
      return this.$vuetify.breakpoint.height - 134
    }
  },

  watch: {
    queryParameters: {
      handler(newValue, oldValue) {
        // console.log('watch queryParameters')
        if (newValue.options.page === oldValue.options.page)
          this.state.options.page = 1
        this.state.selected = []
        this.state.update()
      },
      deep: true
    },
    queryDebounceParameters: {
      handler(newValue, oldValue) {
        // console.log('watch queryDebounceParameters')
        this.state.options.page = 1
        this.state.selected = []
        this.update()
      },
      deep: true
    },
  },

  setup({
          storeName,
          aggregateStoreName,
          detailStoreName,
          showSelect,
          singleSelect,
          height,
          dtoListQuery,
          dtoActionCommand
        }) {
    let state = useTableStore(storeName, aggregateStoreName)()
    state.detailStoreName = detailStoreName
    // console.log('state.detailStoreName', state.detailStoreName)
    let stateDetail = useDetailStore(detailStoreName)()
    state.showSelect = showSelect
    state.singleSelect = singleSelect
    state.height = height
    state.dtoListQuery = dtoListQuery
    state.dtoActionCommand = dtoActionCommand
    return {state, stateDetail}
  },

  methods: {
    onToggleSelectAll(event) {
      // console.log('onToggleSelectAll', event)
      if (event.value === false)
        this.state.selected = []
    },
    rowDefaultBackground(item) {
      return item.item_color
    },
    styleText(width) {
      return `max-width:${width}px`
    },
    update: debounce(function () {
      if (this.items !== null)
        return
      this.state.update()
    }, 500),
    onAction({actionName, actionUid, data = null, callReceive = null}) {
      this.state.onAction({
        actionName: actionName, actionUid: actionUid, data: data, callReceive: callReceive
      })
      if (actionName === 'remove_restore')
        this.state.selected = []
    },
    saveOrder({newIndex, oldIndex}) {
      const row = this.state.uidList.splice(oldIndex, 1)[0]
      this.state.uidList.splice(newIndex, 0, row)
      for (let [index, uid] of this.state.uidList.entries())
        if (this.aggregateStore.rootData[uid].order !== index)
          this.aggregateStore.rootData[uid].order = index
    },
  },

  async mounted() {
    // console.log('mount stateDetail', this.stateDetail)
    this.aggregateStore = useAggregateStore()
    if (this.mainValidator === true) {
      this.aggregateStore.dtoValidateCommand = this.dtoValidateCommand
    }
    let table = document.querySelector(".v-data-table__wrapper tbody")
    Sortable.create(table, {handle: ".handle", sort: true, onUpdate: this.saveOrder})
  },

  data() {
    return {
      self: this,
      aggregateStore: null,
    }
  },
}
</script>

<style scoped>

</style>

<i18n src="@/components/Common/locales.json">
</i18n>